import cx from 'classnames'
import { Popover, type PopoverProps } from 'react-aria-components'

import { paperStyles } from '../../../libs/paperStyles'

type Props = Pick<PopoverProps, 'children'>

export const DatePopover = ({ children }: Props) => (
  <Popover
    offset={4}
    className={cx(
      paperStyles({ borders: ['all'] }),
      'min-w-(--trigger-width) shadow-lg rounded-lg p-1 overflow-auto',
    )}
  >
    {children}
  </Popover>
)
